export const resolveImageErrorKey = (error, fallbackKey) => {
  const status = error?.statusCode || error?.status || error?.response?.status;
  if (status === 402) return 'insufficientBalanceFallback';
  if (status === 401) return 'imageUnauthorizedError';
  if (status === 403) return 'imageForbiddenError';
  if (status === 429) return 'imageRateLimitError';
  if (status === 504 || error?.code === 'TIMEOUT' || error?.code === 'ECONNABORTED') {
    return 'imageTimeoutError';
  }
  if (error?.code === 'NETWORK' || error?.message === 'Network Error') {
    return 'imageNetworkError';
  }
  return fallbackKey;
};

export const isInsufficientBalanceError = (error) => {
  const status = error?.statusCode || error?.status || error?.response?.status;
  return status === 402;
};
